(function () {
  'use strict';

  angular
    .module('sageFlightDataReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('sageFlightDataReport', {
        url: '/sage-flight-data-report',
        views: {
          'sageFlightDataReportView': {
            templateUrl: 'sage-flight-data-report/views/sage-flight-data-report.tpl.html',
            controller: 'SageFlightDataReportCtrl',
            controllerAs: 'sageFlightDataReport'
          }
        }
      });
  }
}());
